import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalConfigurationState } from '../../../../state/global-configuration.state';
import { NexsysOrderMessageModel } from '../../model/nexsys-order-message.model';
import { CreateUpdateComponent } from '../create-update.component';
import { DropdownComponent } from "@cv-invision/cv.component-library.ux";

@Component({
	selector: 'cv-invision-create-update-milestone-message',
	templateUrl: './create-update-milestone-message.component.html',
	styleUrls: ['./create-update-milestone-message.component.scss']
})
export class CreateUpdateMilestoneMessageComponent extends CreateUpdateComponent implements OnInit {
	@ViewChild('statusMilestone') statusMilestone: DropdownComponent;
	public config: any = new NexsysOrderMessageModel();
	public originalConfig: any = new NexsysOrderMessageModel;
	statusAppScope: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysAppScopeMilestoneStatus);
	statusAcuity: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysAcuityMilestoneStatus);
	statusCmpAcuity: Array<any> = this.store.selectSnapshot(GlobalConfigurationState.getNexsysCmpAcuityMilestoneStatus);
	status: Array<any>;
	source = ['AppScope', 'Acuity', 'cmpacuity'];



	ngOnInit(): void {
		this.config.sendConfirmationToOrigin = true;

		super.ngOnInit();

		if (this.data.isEditing) {
			this.config = Object.assign({}, this.data.dataMessage);
			this.onSourceSelected(this.config.origin);
			this.onStatusSelected(this.config.status);

			this.originalConfig = Object.assign({}, this.config);
		}
	}

	/**
	 * handle response from server
	 */
	onStatusSelected($event: any): void {
		this.config.status = $event;
	}

	/**
	 * handle response from server
	 */
	onSourceSelected($event: any): void {
		this.config.origin = $event;
		this.status = [];
		switch (this.config.origin) {
			case 'AppScope':
				this.status = this.statusAppScope;
				break;
			case 'Acuity':
				this.status = this.statusAcuity;
				break;
			case 'cmpacuity':
				this.status = this.statusCmpAcuity;
				break;
			default:
				this.onStatusSelected(null);
				this.status = [];
		}
		this.statusMilestone?.clearValues(null);
	}

	/**
	 *  set sendConfirmationToOrigin value
	 */
	onSendConfirmationToOrigin($event: any): void {
		this.config.sendConfirmationToOrigin = $event;
	}

	/**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		return this.config.origin && this.config.origin.length > 0 &&
			this.config.status && this.config.status.length > 0 &&
			this.config.message && this.config.message.trim().length > 0;
	}
}
